import styled from 'styled-components';

export const Container = styled.div`
  .ambassador-card {
    display: flex;
    flex-direction: column;
    gap: 20px;
    /* Mesmo respiro das caixas de "Nossas Ferramentas" (p-4 do Bootstrap). */
    padding: 1.5rem;
    border-radius: 8px;
    background: ${(props) => props.theme.$white};
    box-shadow: 0px 0px 5px rgba(94, 118, 172, 0.1);
  }

  .ambassador-intro,
  .ambassador-message {
    margin: 0;
    color: ${(props) => props.theme.$gray900};
    font-size: 16px;
    line-height: normal;
  }

  .ambassador-message {
    color: ${(props) => props.theme.$gray600};
    font-size: 14px;
  }

  /* Quatro por linha: a área recolhida mostra a primeira linha (ver ROW_SIZE). */
  .ambassador-tools {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 8px;

    @media only screen and (max-width: 991px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media only screen and (max-width: 575px) {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  .ambassador-more {
    display: inline-flex;
    align-items: center;
    align-self: center;
    gap: 4px;
    padding: 0;
    border: 0;
    background: none;
    color: #10a875;
    font-size: 14px;
    font-weight: 700;

    .material-icons {
      font-size: 20px;
    }
  }

  .ambassador-tool {
    display: flex;
    flex-direction: column;
    gap: 14px;
    min-width: 0;
    padding: 20px 18px;
    border: 1px solid ${(props) => props.theme.$gray400};
    border-radius: 8px;
    background: ${(props) => props.theme.$white};
    color: ${(props) => props.theme.$gray800};
    font-size: 14px;
    line-height: normal;
    text-decoration: none;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  /* Só os cards com ação são links; bloqueados, concluídos e "Em breve" não reagem ao mouse. */
  a.ambassador-tool:hover,
  a.ambassador-tool:focus {
    border-color: #10a875;
    box-shadow: 0px 0px 5px rgba(94, 118, 172, 0.25);
    color: ${(props) => props.theme.$gray800};
    text-decoration: none;
  }

  /* A ferramenta da vez, a última liberada que ainda pede ação. */
  .ambassador-tool.is-current {
    border-color: #10a875;
    box-shadow: inset 0 0 0 1px #10a875;
  }

  .ambassador-tool.is-locked {
    background: ${(props) => props.theme.$gray100};

    .tool-heading,
    .tool-description {
      opacity: 0.6;
    }
  }

  .tool-heading {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
  }

  .tool-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .tool-step {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border: 1px solid ${(props) => props.theme.$gray400};
    border-radius: 50%;
    color: ${(props) => props.theme.$gray600};
    font-size: 12px;
    font-weight: 700;
  }

  .is-current .tool-step {
    border-color: #10a875;
    background: #10a875;
    color: ${(props) => props.theme.$white};
  }

  .tool-icon {
    width: 24px;
    height: 24px;
  }

  /* Mesmo verde dos ícones de "Nossas Ferramentas", que também partem do SVG escuro. */
  img.tool-icon {
    filter: invert(44%) sepia(45%) saturate(1827%) hue-rotate(128deg) brightness(93%) contrast(87%);
  }

  img.tool-icon-colored {
    filter: none;
  }

  .tool-icon-empty {
    border-radius: 4px;
    background: #d2eee7;
  }

  .tool-name {
    font-weight: 700;
  }

  .tool-description {
    display: flex;
    flex-direction: column;
    gap: 16px;
    font-weight: 400;

    p {
      margin: 0;
    }
  }

  /*
   * Fora do esmaecido do card bloqueado, para o motivo do bloqueio não sumir, e
   * junto do rodapé, na mesma altura em todos os cards da linha.
   */
  .tool-notice {
    display: flex;
    align-items: center;
    gap: 4px;
    margin: auto 0 0;
    font-size: 12px;
    font-weight: 700;

    .material-icons {
      flex-shrink: 0;
      font-size: 16px;
    }
  }

  .tool-notice-alert {
    color: ${(props) => props.theme.$danger};
  }

  .tool-notice-done {
    color: #10a875;
  }

  /* No rodapé do card, na mesma altura em todos. */
  .tool-action {
    align-self: center;
    margin-top: auto;
    color: #10a875;
    font-weight: 700;
  }

  .tool-notice + .tool-action {
    margin-top: 0;
  }

  .tool-action-muted {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: ${(props) => props.theme.$gray600};

    .material-icons {
      font-size: 16px;
    }
  }
`;
